const campaignMessagesChartConfig = {
  name: 'campaign_messages_distribution',
  title: 'campaign messages distribution',
  helpText: 'Displays percentage of statuses for a campaign message',
  exportType: 'tabular_chart_data',
  graphParams: {
    dataNameField: 'name',
    dataValueField: 'value',
    colColors: {},
  },
  showLegend: false,
};

export default campaignMessagesChartConfig;
